<template lang="html">
  <div class="saveti">
    <div  id="hero" class="hero">
       <div class="text">

          <h1 class="">"Rast nikad nije slučajan</h1>
          <h1>on je ishod snaga koje rade zajedno"</h1>
          <h1><span> -- Džejms Keš Peni </span> </h1>

       </div>
    </div>
    <router-link to="/saveti"><p v-if="this.$route.params.vrsta" style="float:left; margin:20px 20px;position:absolute"><i class="fas fa-undo"></i></p></router-link>
    <h3>{{vrsta}}</h3>
    <h2>SAVETI - TEHNOLOGIJA PROIZVODNJE {{vrsta}}</h2>


    <div class="wrapper">
      <div  class="container" v-if="!vrsta">
         <div class="card"  v-for="sav in getsaveti" @click="" title="Klikni i pretraži">
            <h3 class="title">{{sav.pod_naziv}}</h3>
            <div class="bar">
              <div class="emptybar"></div>
              <div class="filledbar"></div>
            </div>

             <router-link :to="'/saveti/'+sav.pod_naziv"> <div class="circle">

              <img :src="podkaturl+sav.pod_id"  alt=""  >
            </div></router-link>
          </div>
      </div>
     <!-- <div class="single"  v-if="!vrsta" v-for="sav in getsaveti" >
       <div class="naslov">
         <h3>{{sav.pod_naziv}}</h3>
       </div>
       <div class="container" >
         <router-link :to="'/saveti/'+sav.pod_naziv">Detaljnije</router-link>
       </div>
       {{sav.sav_text}}
    </div> -->
    <div class=""  v-if="vrsta">
      <br>
      <div class="" id="vrsta" v-for="sav in getsavet" v-html="sav.sav_text">
      </div>
      <div class="test" v-for="sl in getsliketest">
        <img :src="saveturl+sl.sltest_id"  alt=""  >
      </div>
    </div>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';

export default {
  data(){
    return{
        vrsta:""

    }
  },
  watch:{
    $route:function(to, from){
      this.vrsta=""
      if(this.$route.params.vrsta){
        this.vrsta=this.$route.params.vrsta
        this.savet(this.$route.params.vrsta)
        console.log(this.getsliketest);
        }else{
          this.saveti()
        }
    },


  },
  created(){
    // this.vrsta=""
    if(this.$route.params.vrsta){
      this.vrsta=this.$route.params.vrsta
      this.savet(this.$route.params.vrsta)
      }else{
        this.saveti()
      }


},
  computed:{
    ...mapGetters([
        'getsavet',
        'getsaveti',
        'podkaturl',
        'saveturl',
        'getsliketest'
    ]),


  },
  methods:{

    ...mapActions([
        'savet',
        'saveti'
    ]),

},

  mounted(){
    document.getElementById('myheader').scrollIntoView();
    window.scroll(0,0);
    // this.checksession(this.getsid)

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/saveti.vue